module.exports = __webpack_public_path__ + "img/logo-menu-branco.b5adaf7d.png";